/**
 * Tema claro ou escuro, escolhido pela pessoa e lembrado entre as visitas.
 *
 * A mesma chave é lida pelo bootstrap e pelo provider. Sem preferência válida,
 * vale o escuro; com storage bloqueado, a escolha dura nesta visita.
 */
export type Tema = 'dark' | 'light';

export const CHAVE_TEMA = 'devclub-member-home-theme';

let temaEmMemoria: Tema = 'dark';
let preferenciaNaoGravada = false;

export function temaSalvo(): Tema {
  if (preferenciaNaoGravada) return temaEmMemoria;
  try {
    temaEmMemoria = localStorage.getItem(CHAVE_TEMA) === 'light' ? 'light' : 'dark';
  } catch {
    return temaEmMemoria;
  }
  return temaEmMemoria;
}

function aplicarTema(tema: Tema) {
  const root = document.documentElement;
  root.classList.toggle('dark', tema === 'dark');
  root.setAttribute('data-platform-theme', tema);
  root.style.colorScheme = tema;
}

export function salvarTema(tema: Tema) {
  temaEmMemoria = tema;
  aplicarTema(tema);
  try {
    localStorage.setItem(CHAVE_TEMA, tema);
    preferenciaNaoGravada = false;
  } catch {
    preferenciaNaoGravada = true;
  }
}
